import React, { useState } from 'react';
import './FloatingContactButton.css';
import ContactFormModal from './ContactFormModal';

function FloatingContactButton() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <button 
        className="floating-contact-button"
        onClick={openModal}
        aria-label="راسلنا"
        title="راسلنا"
      >
        <svg viewBox="0 0 24 24" fill="currentColor" className="button-icon">
          <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"/>
        </svg>
        <span className="button-text">راسلنا</span>
      </button>

      {isModalOpen && (
        <ContactFormModal onClose={closeModal} />
      )}
    </>
  );
}

export default FloatingContactButton;
